import styled from 'styled-components';
import spacing from '../../../helpers/spacing';
import { Grid, GridItem } from '../../Grid';

export const CardGridItem = styled(GridItem)`
  /* Make card full height */
  display: flex;

  /* Make card full width */
  & > * {
    width: 100%;
  }
`;

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};
  }
`;
